
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiResizeTop as ObiResizeTopElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-resize-top.js';
 
 
 

 
 export const ObiResizeTop = createComponent({
   react: React,
   tagName: 'obi-resize-top',
   elementClass: ObiResizeTopElement,
   events: {
     
   }
  });
 
 